import { render, staticRenderFns } from "./MobService.vue?vue&type=template&id=5b1477f9&scoped=true&"
import script from "./MobService.vue?vue&type=script&lang=js&"
export * from "./MobService.vue?vue&type=script&lang=js&"
import style0 from "./MobService.vue?vue&type=style&index=0&id=5b1477f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1477f9",
  null
  
)

export default component.exports